<button
  type="button"
  id="ai-chatbot-branding-toggle"
  class="branding-toggle"
  [class.branding-toggle-on]="aiChatbotService.showBranding()"
  [attr.aria-pressed]="aiChatbotService.showBranding()"
  aria-label="Toggle company branding on AI-generated previews"
  (click)="onToggle()"
>
  @if (aiChatbotService.showBranding()) {
    <span class="branding-toggle-logo" aria-hidden="true">
      <span class="branding-toggle-logo-half branding-toggle-logo-blue"></span>
      <span class="branding-toggle-logo-half branding-toggle-logo-green"></span>
    </span>
  } @else {
    <mat-icon
      class="branding-toggle-icon"
      svgIcon="branding-palette"
      aria-hidden="true"
    ></mat-icon>
  }
  <span class="branding-toggle-label">Branding</span>
  @if (aiChatbotService.showBranding()) {
    <mat-icon
      class="branding-toggle-check"
      svgIcon="branding-check"
      aria-hidden="true"
    ></mat-icon>
  }
</button>
